import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPolandFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M30.0003 0.000488286C37.9566 0.000701073 45.587 3.16144 51.213 8.78742C56.8389 14.4134 59.9997 22.0438 60 30.0002H0C4.07549e-05 26.0605 0.776055 22.1594 2.28373 18.5197C3.79141 14.8799 6.00123 11.5727 8.78702 8.787C11.5728 6.00127 14.88 3.79152 18.5198 2.28393C22.1596 0.776332 26.0606 0.000419696 30.0003 0.000488286V0.000488286Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M30.0003 60.0008C22.0438 60.0007 14.4132 56.8399 8.78707 51.2138C3.16095 45.5877 0.000154577 37.9571 0 30.0005H60C59.9998 37.957 56.8391 45.5875 51.2131 51.2136C45.5871 56.8397 37.9567 60.0005 30.0003 60.0008Z",
		fill: "#ED4C5C"
	})]
});
export default SvgPolandFlag;
